import { z } from 'zod';

export const ValuationModelSchema = z.enum([
  'dcf',
  'spm_dcf',
  'ev_ebitda',
  'sum_of_parts',
  'asset_based',
  'optionality',
]);

export const ValuationRunSchema = z.object({
  valuationRunId: z.string(),
  securityId: z.string(),
  models: z.array(ValuationModelSchema),
  fairValueRange: z.object({
    low: z.number(),
    mid: z.number(),
    high: z.number(),
    currency: z.string(),
  }),
  currentPrice: z.number().optional(),
  discountPct: z.number().optional(),
  protectionScore: z.number().min(0).max(100).optional(),
  assumptions: z.record(z.unknown()),
  sourceIds: z.array(z.string()).min(1),
  knownAt: z.string(),
  glossaryTermId: z.string(),
});

export type ValuationRun = z.infer<typeof ValuationRunSchema>;

export const TpsScoreSchema = z.object({
  entityId: z.string(),
  overallScore: z.number().min(0).max(100).nullable(),
  immunityDimensions: z.array(z.object({
    dimension: z.string(),
    score: z.number().min(0).max(100).nullable(),
    coverage: z.enum(['complete', 'partial', 'unknown']),
    glossaryTermId: z.string(),
  })),
  protectedNodeTest: z.object({
    passed: z.boolean().nullable(),
    rationale: z.string(),
    unknowns: z.array(z.string()).default([]),
  }),
  sourceIds: z.array(z.string()).min(1),
});

export type TpsScore = z.infer<typeof TpsScoreSchema>;
